import { render, staticRenderFns } from "./SubmitInspections.vue?vue&type=template&id=22f8f56c&scoped=true&"
import script from "./SubmitInspections.vue?vue&type=script&lang=ts&"
export * from "./SubmitInspections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f8f56c",
  null
  
)

export default component.exports